let marketPlaceConfig = {
    "marketPercent": 0.0001,
    "maxHours": 120,
    "minHours": 5,
    "minPriceMultiplier": 0.5,
    "priceHighLimit": 2500000,
    "priceLowLimit": 40000,
    "removeLotPrice": 1000,
    "servicePercent": 0.01,
    "timeRuleToAddByBet": 60,
    "timeAddAuctionByBet": 30,
    "auctionTime": 12,
    "betStep": 100000
};

export default marketPlaceConfig;